// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"42b5ff67","453":"3d48e2ce","455":"c4b04009","952":"abd600e6"}[chunkId] + ".chunk.js";
};